// @index(['./!(*.spec).ts', './*/index.ts'], f => `export * from '${f.path.replace(/\/index$/, '')}';`)
export * from './manage-subscription.directive';
export * from './market-provider.directive';
export * from './products-for-type.directive';
export * from './purchase.directive';
// @endindex